import React, { useState, useMemo } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import {
  Button,
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Modal,
  Paper,
  Tab,
  Tabs,
  Typography
} from '@material-ui/core';

const VendorInfoModal = (props) => {

  const [tabValue, setTabValue] = useState(0);

  const expectedList = useMemo(() => {
    const initialExpectedList = [];

    for ( let i = 0; i < props.vendorInfo.expectedExpenses.length; i++ ) {
      const expectedExpense = props.vendorInfo.expectedExpenses[i];
      initialExpectedList.push({
        expectedExpense: expectedExpense.total,
        monthYear: moment(expectedExpense.monthYear).format("MMMM / YYYY"),
        creationDate: moment(expectedExpense.createdAt).format("DD/MM/YYYY")
      });
    }
  
    return initialExpectedList;
  
  }, [props.vendorInfo.expectedExpenses]);

  const { totalBalance, expenseList, totalExpensesList } = useMemo(() => {

    let totalBalanceBuffer = 0;
    let expenseListBuffer = [];
    let totalExpensesListBuffer = [];

    let startDate = moment(props.vendorInfo.joiningDate);
    let todaysDate = moment().startOf('day');

    for ( let i = 0; i < props.expenses.length; i++ ) {
      // Condition to check if any Vendor Expense is present in Expenses.
      if(props.vendorInfo.id === props.expenses[i].vendorId) {
        const expense = props.expenses[i];
        expenseListBuffer.push({
          displayId: expense.displayId,
          monthYear: moment(expense.monthYear).format("MMMM / YYYY"),
          amount: expense.total,
          description: expense.description,
          momentDate: expense.monthYear,
          txnDate: moment(expense.createdAt).format("DD/MM/YYYY")
        });
      }
    }

    // The additional 'OR' condition is important to make sure the loop runs even if the months are the same.
    while (startDate.isBefore(todaysDate) || startDate.isSame(todaysDate, 'month')) {

      let totalMonthExpenses = expenseListBuffer.reduce((prevExpense, currentExpense) => {
        if(startDate.isSame(currentExpense.momentDate, 'month')) return prevExpense + currentExpense.amount;
        else return prevExpense;
      }, 0);
      let totalMonthExpectedExpense = props.vendorInfo.expectedExpenses.find(expectedExpense => startDate.isSame(expectedExpense.monthYear, 'month'))?.total || 0;

      totalBalanceBuffer += totalMonthExpectedExpense - totalMonthExpenses;
      totalExpensesListBuffer.push({
        monthYear: startDate.format("MMMM / YYYY"),
        expectedExpense: totalMonthExpectedExpense,
        totalExpenses: totalMonthExpenses,
        balance: totalMonthExpectedExpense - totalMonthExpenses
      });

      startDate.add(1, 'month');
    }

    return {
      totalBalance: totalBalanceBuffer,
      expenseList: expenseListBuffer,
      totalExpensesList: totalExpensesListBuffer
    }

  }, [props.expenses, props.vendorInfo]);

  const columns = [
    { label: "Expense ID", name: "displayId" },
    { label: "Month & Year", name: "monthYear" },
    { label: "Amount", name: "amount" },
    { label: "Description", name: "description" },
    { label: "Expected Expense", name: "expectedExpense" },
    { label: "Transaction Date", name: "txnDate" },
    { label: "Creation Date", name: "creationDate" },
    { label: "Total Expenses", name: "totalExpenses" },
    {
      label: "Balance Amount",
      name: "balance",
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta) => (
          <font color={ value < 0 ? "red" : null }>{value}</font>
        )
      }
    }
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const options = {
    selectableRows: 'none',
    viewColumns: false
  };

  return (
    <Modal open={props.open}>
      <Card>
        <CardHeader
          subheader="Review all the Expenses of the Vendor"
          title="Vendor History"
        />
        <Divider />
        <CardContent>
          <Box>
            <Box
              sx={{
                display: 'flex'
              }}
            >
              <Paper>
                <Tabs
                  value={tabValue}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleTabChange}
                  centered
                >
                  <Tab label="Vendor Expenses"/>
                  <Tab label="Expected Expense"/>
                  <Tab label="Total Expenses"/>
                </Tabs>
              </Paper>
            </Box>
            { tabValue === 0 ?
              <Box
                sx={{
                  overflow: 'auto',
                  height: 458
                }}
              >
                <MUIDataTable
                  title={"Vendor Expenses"}
                  data={expenseList}
                  columns={columns.filter(column => !["expectedExpense","creationDate","totalExpenses","balance"].includes(column.name))}
                  options={options}
                />
              </Box>
            : null }
            { tabValue === 1 ?
              <Box
                sx={{
                  overflow: 'auto',
                  height: 458
                }}
              >
                <MUIDataTable
                  title={"Expected Expense"}
                  data={expectedList}
                  columns={columns.filter(column => ["monthYear","expectedExpense","creationDate"].includes(column.name))}
                  options={options}
                />
              </Box>
            : null }
            { tabValue === 2 ?
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '1%'
                  }}
                >
                  <Typography
                    align="center"
                    color="textPrimary"
                    variant="h5"
                  >
                    Total Balance Amount : <font color={ totalBalance < 0 ? "red" : null }>{totalBalance} AED</font>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    overflow: 'auto',
                    height: 407
                  }}
                >
                  <MUIDataTable
                    title={"Total Expenses"}
                    data={totalExpensesList}
                    columns={columns.filter(column => ["monthYear","expectedExpense","totalExpenses","balance"].includes(column.name))}
                    options={options}
                  />
                </Box>
              </Box>
            : null }
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '1%'
              }}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={props.closeModal}
              >
                Close
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Modal>
  )
};

export default VendorInfoModal;